import angular from 'angular';
import { AngularServices } from '../modules/core';
import { RootScopeEvents } from '../common/services/root-scope-types';
/* @ngInject */
function globalUi($timeout, $rootScope, $log) {
    const debug = $log.debug.bind($log, 'globalUi:');
    const ui = {
        _screenSharing: false,
        sidebarHidden: false,
        noScrollbar: false,
        modalOpen: false,
        video: false,
        checkIn: true,
        patientCheckIn: false,
        newMessages: 0,
        activeStreamId: null,
        pinnedStreamId: null,
        // indicates status of gallery view (either Gallery or Standard view is activated)
        isGalleryViewActivated: false,
        // indicates visibility of gallery view button (can be hidden if screensharing is enabled)
        isGalleryViewButtonHidden: false,
        isRestartingCall: false,
        set screenSharing(value) {
            let isEnabled = false;
            let constraints = null;
            if (typeof value === 'boolean') {
                isEnabled = value;
            }
            else {
                isEnabled = true;
                constraints = value;
            }
            if (isEnabled === this._screenSharing) {
                return;
            }
            $rootScope.$evalAsync(() => {
                this._screenSharing = isEnabled;
                $rootScope.$emit(RootScopeEvents.GLOBAL_UI.SCREEN_SHARING_UPDATED, isEnabled, constraints);
            });
        },
        get screenSharing() {
            return this._screenSharing;
        },
        // triggers temporary gallery view deactivation when Whiteboard extension launched during the group call, and reactivation after WB finished.
        isShowingWhiteboard: false,
        isShowingAdherely: false,
    };
    return {
        ui,
        PATIENT_CHECK_IN_CLOSE_POPUP_DELAY: 0,
        PRECALL_TEST_CANCEL_DELAY: 1600,
        PATIENT_MODAL_RESET_WAIT_TRANSITION_TIME: 1000,
        get isAnybodyScreenSharing() {
            return ui.screenSharing || this.ui.screenSharePatient;
        },
        startCall() {
            debug('startCall');
            this.set({ video: true });
            $rootScope.$emit('globalUi:startCall');
        },
        endCall() {
            debug('endCall');
            this.set({
                video: false,
                videoEndedAt: Date.now(),
            });
            $rootScope.$emit('globalUi:endCall');
        },
        set: function (params) {
            debug('set', params);
            void $timeout(() => {
                angular.extend(ui, params);
                if (undefined !== params.newMessages) {
                    $rootScope.$emit('globalUi:newMessages');
                }
            });
        },
        toggleSidebar: function (condition) {
            this.set({
                sidebarHidden: angular.isUndefined(condition)
                    ? !ui.sidebarHidden
                    : Boolean(condition),
            });
        },
        toggleVideo: function (condition) {
            this.set({
                video: angular.isUndefined(condition) ? !ui.video : Boolean(condition),
                sidebarHidden: angular.isUndefined(condition)
                    ? !ui.sidebarHidden
                    : Boolean(condition),
            });
        },
    };
}
export default angular
    .module('doxy.global.ui', [])
    .factory(AngularServices.GlobalUi, globalUi).name;
